module.exports = __webpack_public_path__ + "media/images/views/home/home-section-intro-small-d46b41fc862947cf840cac8b62815d79.png";